import { render } from "./NoteSidebar.vue?vue&type=template&id=b01a08f8&scoped=true"
import script from "./NoteSidebar.vue?vue&type=script&lang=js"
export * from "./NoteSidebar.vue?vue&type=script&lang=js"

import "./NoteSidebar.vue?vue&type=style&index=0&id=b01a08f8&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01a08f8"]])

export default __exports__